/* global axios */
const BASE = '/api/v1/ardhisasa/land';
const authHeaders = (token, jwt) => ({
  'X-Ardhisasa-Token': token,
  'X-Ardhisasa-Jwt': jwt,
});

export const getSerialDocument = (token, jwt, params) =>
  axios.get(`${BASE}/serial-document`, {
    headers: authHeaders(token, jwt),
    params,
  });

export const getInvoiceDetail = (token, jwt, referenceNum) =>
  axios.get(`${BASE}/invoice-detail`, {
    headers: authHeaders(token, jwt),
    params: { reference_num: referenceNum },
  });

export const getParcelPropertyInfo = (
  token,
  jwt,
  parcelNumber,
  natureOfTitle = ''
) =>
  axios.get(`${BASE}/parcel-property-info`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber, nature_of_title: natureOfTitle },
  });

export const getParcelSurvey = (token, jwt, parcelNumber) =>
  axios.get(`${BASE}/parcel-survey`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber, srid: 4326 },
  });

export const getParcelStatus = (token, jwt, parcelNumber) =>
  axios.get(`${BASE}/parcel-status`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber },
  });

export const getParcelCadaster = (token, jwt, parcelNumber) =>
  axios.get(`${BASE}/parcel-cadaster`, {
    headers: authHeaders(token, jwt),
    params: { property_number: parcelNumber },
  });

export const getParcelLease = (token, jwt, parcelNumber) =>
  axios.get(`${BASE}/parcel-lease`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber },
  });

export const getLandRegister = (token, jwt, parcelNumber, natureOfTitle) =>
  axios.get(`${BASE}/land-register`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber, nature_of_title: natureOfTitle },
  });

export const getRentInvoices = (token, jwt, parcelNumber, page = 1) =>
  axios.get(`${BASE}/rent-invoices`, {
    headers: authHeaders(token, jwt),
    params: { parcel_number: parcelNumber, page },
  });

export const getRegistrationByParcel = (
  token,
  jwt,
  parcelNumber,
  applicationStatus = ''
) =>
  axios.get(`${BASE}/registration-by-parcel`, {
    headers: authHeaders(token, jwt),
    params: {
      parcel_number: parcelNumber,
      application_status: applicationStatus || undefined,
    },
  });

export const getProcessDetail = (token, jwt, processName, id) =>
  axios.get(`${BASE}/process-detail`, {
    headers: authHeaders(token, jwt),
    params: { process_name: processName, id },
  });
